import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import AppBar from "@material-ui/core/AppBar";
import Snackbar from "@material-ui/core/Snackbar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  secondaryBar: {
    zIndex: 0
  }
});

function TabBar({ classes, tabNames = [], index }) {
  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const handleAction = async tabName => {
    try {
      await tabName.fn();
      if (tabName.successMessage) {
        setSnackbarMessage(tabName.successMessage);
      }
    } catch (error) {
      if (tabName.errorMessage) {
        setSnackbarMessage(tabName.errorMessage);
      }
    }
  };

  return (
    <>
      <AppBar
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="static"
        elevation={0}
      >
        <Tabs value={index} textColor="inherit">
          {tabNames.map(tabName =>
            tabName.page ? (
              <Link
                key={tabName.label}
                style={{ textDecoration: "none", color: "inherit" }}
                to={`${tabName.page}`}
              >
                <Tab textColor="inherit" label={`${tabName.label}`} />
              </Link>
            ) : (
              <Tab
                key={tabName.label}
                textColor="inherit"
                label={`${tabName.label}`}
                onClick={() => handleAction(tabName)}
              />
            )
          )}
        </Tabs>
      </AppBar>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={Boolean(snackbarMessage)}
        autoHideDuration={4000}
        onClose={() => setSnackbarMessage("")}
        message={snackbarMessage}
      />
    </>
  );
}

TabBar.propTypes = {
  classes: PropTypes.object.isRequired,
  tabNames: PropTypes.array.isRequired
};

export default withStyles(styles)(TabBar);
